'use strict';
import defaults from 'lodash/defaults';
import isFunction from 'lodash/isFunction';
import {ajax} from 'rxjs/observable/dom/ajax';
import {isWebView} from '../../../core-utilities-implementation/device-services/DeviceServicesCordova';
import {Observable} from "rxjs/Observable";

const BASE_EPICS_OPTIONS = {
  crossDomain: false,
  requestTimeout: 0, // TODO: experiment
  responseType: 'json',
};

/**
 * @typedef {Object} AjaxFactoryOptions
 * @property {Boolean} [crossDomain=false]
 * @property {HttpMethod|AjaxFactoryOptions~method<T>} method
 * @property {Boolean} useBody
 * @property {Number} [requestTimeout=0]
 * @property {AjaxFactoryOptions~responseType|String} [responseType='json']
 * @property {String|AjaxFactoryOptions~url<T>} url
 * @property {AjaxFactoryOptions~modifyRequestConfig<T>} [modifyRequestConfig]
 * @property {AjaxFactoryOptions~modifyHeaders<T>} [modifyHeaders]
 * @property {AjaxFactoryOptions~serializeBody} [serializeBody=JSON.stringify]
 * @property {AjaxFactoryOptions~getBody}
 * @property {AjaxFactoryOptions~getToken} getToken
 * @template T
 */

/**
 * @callback AjaxFactoryOptions~responseType<T>
 * @param {T} request
 * @return {String}
 * @template T
 */

/**
 * @callback AjaxFactoryOptions~url<T>
 * @param {T} request
 * @return {String}
 * @template T
 */

/**
 * @callback AjaxFactoryOptions~method<T>
 * @param {T} request
 * @return {HttpMethod}
 * @template T
 */

/**
 * @callback AjaxFactoryOptions~getToken<T>
 * @param rootState Redux root state.
 * @return {String}
 * @template T
 */

/**
 * @callback AjaxFactoryOptions~modifyRequestConfig<T>
 * @param {AjaxRequest} config
 * @param {T} request
 * @return {AjaxRequest}
 * @template T
 */

/**
 * @callback AjaxFactoryOptions~modifyHeaders<T>
 * @param {Object} headers
 * @param {T} request
 * @return {Object}
 * @template T
 */

/**
 * @callback AjaxFactoryOptions~serializeBody
 * @param {any} body
 * @return {any}
 */

/**
 * @callback AjaxFactoryOptions~getBody
 * @param {any} body
 * @return {Object | Array}
 */

/**
 * @typedef {Object} AjaxFactory<T>
 * @template T
 */
export class AjaxFactory {
  static NO_AUTH = 'Cannot send request without auth token!';

  static jsonResponseType = request => 'json';

  /**
   * @param {AjaxFactoryOptions<T>} o
   */
  constructor(o) {
    const options = {};
    defaults(options, o, BASE_EPICS_OPTIONS);
    /** @type {AjaxFactoryOptions<T>} */
    this._options = options;

    /** @type {AjaxCreationMethod} */
    this.ajax = ajax;
  }

  /**
   * @param {T} request
   * @param rootState Redux root state.
   * @return {Observable<ReduxAction>}
   * @public
   */
  sendRequest(request, rootState) {
    // console.log('AjaxFactory.sendRequest', request);
    if (isWebView()) {
      /*
       if (!window.ran_once) {
        window.ran_once = true

        const API_URL = 'https://i77h1p24pk.execute-api.us-east-1.amazonaws.com'
        const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuaWNrbmFtZSI6Impvbm55dGVzdGVyIiwibmFtZSI6Impvbm55dGVzdGVyQG1haWxpbmF0b3IuY29tIiwicGljdHVyZSI6Imh0dHBzOi8vcy5ncmF2YXRhci5jb20vYXZhdGFyLzU0YjAwNTkzODZhY2NjZmFiYzBhNWVjMWNiMzgwYTBiP3M9NDgwJnI9cGcmZD1odHRwcyUzQSUyRiUyRmNkbi5hdXRoMC5jb20lMkZhdmF0YXJzJTJGam8ucG5nIiwidXBkYXRlZF9hdCI6IjIwMjUtMDQtMTBUMDQ6NTM6NTIuNzA3WiIsImVtYWlsIjoiam9ubnl0ZXN0ZXJAbWFpbGluYXRvci5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6Ly91cGxpbmsuYXV0aDAuY29tLyIsImF1ZCI6Ilp5RW1UeGNUZEV1M1Y4VDZmWjZCWmROUWRMMXowSFY3Iiwic3ViIjoiYXV0aDB8NWJjNjcyZGY0YjBjN2U1YmExZDk5Yzk4IiwiaWF0IjoxNzQ0MjYwODMzLCJleHAiOjE3NDQ1MjAwMzN9.Lzl_20LY3jRVuD69nesFuIpLzV1UxKH8lFoSUHTobQY'

        try {
          console.log(window.cordova)
          window.cordova.plugin.http.sendRequest(
            `${API_URL}/api/tasks`,
            {
              method: 'post',
              headers: {
                accept: 'application/json',
                authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
              responseType: 'json',
              serializer: 'json',
              data: {
                name: 'foo',
              },
            },
            response => {
              console.log(
                'cordova.plugin.http.sendRequest response',
                this.processCordovaResponse(response, 'json'),
              );
            },
            error => {
              console.error('cordova.plugin.http.sendRequest error', this.processCordovaError(error));
            });

          window.cordova.plugin.http.sendRequest(
            `${API_URL}/api/organizations/-K5UFaiZw8e3-7nii3eT/projects?page=0&pageSize=5`,
            {
              method: 'get',
              headers: {
                accept: 'application/json',
                authorization: `Bearer ${token}`,
              },
              responseType: 'text',
            },
            response => {
              console.log('cordova.plugin.http.sendRequest response', {
                response: response.data,
                responseType: 'json',
                status: response.status,
              });
            },
            error => {
              console.error('cordova.plugin.http.sendRequest error', this.processCordovaError(error));
            });
        } catch (error) {
          console.error('cordova.plugin.http.sendRequest failed', error);
        }

        ajax({
          url: `${API_URL}/api/tasks`,
          method: 'post',
          headers: {
            accept: 'application/json',
            authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          responseType: 'json',
          body: JSON.stringify({
            name: 'foo',
          })
        }).toPromise()
          .then(response => {
            console.log('rxjs.ajax response', response);
          })
          .catch(error => {
            console.log('rxjs.ajax error', error);
          })
      }
       */
      return Observable.create(observer => {
        const url = this.getUrl(request);
        const config = this.getCordovaRequestConfig(request, rootState);
        const msg = `[CordovaHTTP][AjaxFactory] ${config.method.toUpperCase()} ${url}`;
        let requestId = null
        try {
          requestId = window.cordova.plugin.http.sendRequest(
            url,
            config,
            response => {
              requestId = null;
              const res = this.processCordovaResponse(response, config.responseType);
              console.log(`${msg} response`, {
                url,
                config,
                response: res,
              });
              observer.next(res);
              observer.complete();
            },
            response => {
              requestId = null;
              if (response.status >= 300 && response.status < 400) {
                const res = {
                  response: this.parseCordovaError(response.error),
                  responseType: config.responseType,
                  status: response.status,
                }
                // not a real error...
                console.log(`${msg} response`, {
                  url,
                  config,
                  response: res,
                });
                observer.next(res);
                observer.complete();
                return
              }

              const res = this.processCordovaError(response);
              console.error(`${msg} error`, {
                url,
                config,
                error: res,
                options: this._options,
              });
              observer.error(res);
            },
          );
        } catch (error) {
          console.error(`${msg} threw Exception`, {
            url,
            config,
            error,
            options: this._options,
          });
        }

        return () => {
          if (requestId !== null) {
            cordova.plugin.http.abort(requestId)
          }
        };
      });
    }

    return this.ajax(this.getRequestConfig(request, rootState));//.do(r => console.log('AjaxFactory.response', r));
  }

  processCordovaResponse(response, responseType) {
    return {
      response: response.data,
      responseType: responseType,
      status: response.status,
    }
  }

  processCordovaError(response) {
    return {
      response: this.parseCordovaError(response.error),
      status: response.status,
    };
  }

  parseCordovaError(error) {
    const type = typeof error;
    switch (type) {
      case 'undefined':
        return {};
      case 'string':
        try {
          return JSON.parse(error);
        } catch (e) {
          return { message: error };
        }
      case 'object':
        return error ? error : { message: 'Unexpected error occurred' };
      default:
        console.warn(`Unsupported error type from cordova.plugin.http.sendRequest "${type}"`, error);
        return {
          message: 'Unexpected error occurred',
        };
    }
  }

  /**
   * @param {T} request
   * @param rootState Redux root state.
   * @return {AjaxRequest}
   * @protected
   */
  getRequestConfig(request, rootState) {
    const body = this._options.useBody ? this.getBody(request) : null;

    /** @type {AjaxRequest} */
    const config = {
      crossDomain: this._options.crossDomain,
      headers: this.getHeaders(request, rootState, body),
      method: this.getMethod(request),
      responseType: this.getResponseType(request),
      timeout: this._options.requestTimeout,
      url: this.getUrl(request),
    };

    if (this._options.useBody) {
      config.body = body;
      config.headers['Content-Type'] = this.contentType();
    } if ((this._options.method === 'POST' || this._options.method === 'PATCH') && !this._options.useBody) {
      config.body = {};
    }

    return isFunction(this._options.modifyRequestConfig) ? this._options.modifyRequestConfig(config, request) : config;
  }

  /**
   * @param {T} request
   * @param rootState Redux root state.
   * @return {any}
   * @protected
   */
  getCordovaRequestConfig(request, rootState) {
    const config = {
      headers: this.getHeaders(request, rootState),
      method: this.getMethod(request),
      responseType: this.getResponseType(request),
      timeout: this._options.requestTimeout,
    };

    const body = this._options.useBody ? this.getCordovaBody(request) : null;
    if (this._options.useBody && body) {
      config.data = body;
      config.serializer = this.cordovaSerializer();
      config.headers['Content-Type'] = this.contentType();
    } if ((this._options.method === 'POST' || this._options.method === 'PATCH') && !this._options.useBody) {
      config.body = {};
      config.data = {};
    }

    return isFunction(this._options.modifyRequestConfig) ? this._options.modifyRequestConfig(config, request) : config;
  }

  contentType() {
    switch (this._options.contentType) {
      case 'json':
      case undefined:
        return 'application/json';
      default:
        console.warn(`Unsupported content type ${this._options.contentType}`);
        return this._options.contentType
    }
  }

  cordovaSerializer() {
    switch (this._options.contentType) {
      case 'json':
      case undefined:
        return 'json';
      default:
        console.warn(`Unsupported content type ${this._options.contentType}`);
        return this._options.contentType
    }
  }

  // Request config helpers

  /**
   * @param {T} request
   * @return {String}
   * @protected
   */
  getResponseType(request) {
    return isFunction(this._options.responseType) ? this._options.responseType(request) : this._options.responseType;
  }

  hasRequiredAuth(rootState) {
    if (this._options.getToken) {
      const token = this._options.getToken(rootState);
      if (!token) {
        return false;
      }
    }
    return true;
  }

  /**
   * @param {T} request
   * @param rootState Redux root state.
   * @return {Object}
   * @protected
   */
  getHeaders(request, rootState) {
    const headers = {};
    headers['Accept'] = 'application/json';

    if (this._options.getToken) {
      const token = this._options.getToken(rootState);
      if (token) {
        headers['Authorization'] = `Bearer ${this._options.getToken(rootState)}`;
      } else {
        throw new Error(AjaxFactory.NO_AUTH);
      }
    }

    return isFunction(this._options.modifyHeaders) ? this._options.modifyHeaders(headers, request) : headers;
  }

  /**
   * @param {T} request
   * @return {String}
   * @protected
   */
  getBody(request) {
    return isFunction(this._options.serializeBody) ? this._options.serializeBody(request) : JSON.stringify(request);
  }

  /**
   * @param {T} request
   * @return {Object | Array}
   * @protected
   */
  getCordovaBody(request) {
    return isFunction(this._options.getBody) ? this._options.getBody(request) : request
  }

  /**
   * @param {T} request
   * @return {HttpMethod}
   * @protected
   */
  getMethod(request) {
    return isFunction(this._options.method) ? this._options.method(request) : this._options.method;
  }

  /**
   * @param {T} request
   * @return {String}
   * @protected
   */
  getUrl(request) {
    return isFunction(this._options.url) ? this._options.url(request) : this._options.url;
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/redux-observable-list/src/AjaxFactory.js